<template>
    <section
        class="features-tiles section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="features-tiles-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content reveal-from-bottom" data-reveal-delay="150" />
                <div class="container-sm reveal-from-bottom" data-reveal-delay="300" data-reveal-offset="0" style="padding-bottom:80px">
                    <div class="illustration-element-02">
                        <c-image
                            class="has-shadow"
                            :src="require('@/assets/images/struvital-images/system.png')"
                            alt="Features placeholder"
                            :width="896"
                            :height="502" />
                    </div>
                </div>
                <div
                    class="tiles-wrap"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-01.svg')"
                                        alt="Feature tile icon 01"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Doseren
                                </h4>
                                <p class="m-0 text-sm">
                                   Het doseersysteem is geschikt voor elke type stalvloer en werkt prima samen met een mestschuif en mestrobot.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="150">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-02.svg')"
                                        alt="Feature tile icon 02"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Installatie
                                </h4>
                                <p class="m-0 text-sm">
                                    Naast een basis systeem (opslagtank en besturingskast) bestaat het doseersysteem uit een of meerdere secties die op in de stal gemonteerd worden. De specifieke installatie hangt af van de plattegrond (layout) en afmetingen van de vloeren in de stal.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="300">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-03.svg')"
                                        alt="Feature tile icon 03"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Afmetingen
                                </h4>
                                <p class="m-0 text-sm">
                                    Hoe groter de stal hoe meer elementen (leidingen en verstuivers) er nodig zijn. Afhankelijk van de afmetingen van de stal en aantal vloeren zullen een of meerdere secties nodig zijn. 
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="450">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-04.svg')"
                                        alt="Feature tile icon 04"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Optimale Hoeveelheid
                                </h4>
                                <p class="m-0 text-sm">
                                    Elke doseersectie is afzonderlijk te besturen, en wordt zo aangesloten dat er een optimale hoeveelheid vloeistof gesdoseerd wordt over een zo groot mogelijk vloeroppervlak zonder de (tegenoverliggende) boxen nat te maken.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="600">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-05.svg')"
                                        alt="Feature tile icon 05"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Kosten
                                </h4>
                                <p class="m-0 text-sm">
                                    Om de exacte kosten van het Struvital systeem te kunnen bepalen is een plattegrond (schema) van de stal nodig en ook de hoeveel koeien in de stal. Deze gevens kunt u in het <a href="#contact">formulier</a> invullen en naar ons verzenden dan krijgt u een op maat gemaakte offerte. Lease/financiering mogelijk.                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="750">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-06.svg')"
                                        alt="Feature tile icon 06"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Beveiligd en Geborgd
                                </h4>
                                <p class="m-0 text-sm">
                                    Het systeem is beveiligd en geborgd, de data wordt opgeslagen in de cloud en is eenvoudig toegankelijk via een web app.
                                </p>
                            </div>
                        </div>
                    </div>

                        <div class="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="750">
                            <div class="tiles-item-inner">
                                <div class="features-tiles-item-header">
                                    <div class="features-tiles-item-image mb-16">
                                        <c-image
                                            :src="require('@/assets/images/feature-tile-icon-06.svg')"
                                            alt="Feature tile icon 06"
                                            :width="56"
                                            :height="56" />
                                    </div>
                                </div>
                                <div class="features-tiles-item-content">
                                    <h4 class="mt-0 mb-8">
                                        Bijvullen van vloeistof
                                    </h4>
                                    <p class="m-0 text-sm">
                                        De hoeveelheid vloeistof die jaarlijks nodig is, is afhankelijk van het aantal koeien en het te doseren vloeroppervlak. Indien de voorraad vloeistof leeg begint te raken wordt automatisch een reminder gestuurd om vloeistof bij te bestellen zodat die in de opslagtank bijgevuld kan worden.
                                    </p>
                                </div>
                            </div>
                        </div>                    
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CFeaturesTiles',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title:
          'Wat is StruVital?',
        paragraph:
          'Struvital is een geautomatiseerd systeem dat dagelijks meerdere keren een geoptimaliseerde hoeveelheid vloeistof over de roostervloeren in de stal doseert. Wanneer, hoeveel, hoe vaak en in welke verdunningsverhouding er gedoseerd wordt bepaald door een computer die allerlei omgevingsaspecten meeneemt in de beslissing waarbij de dagelijkse amoniak emissie uitstoot zo laag mogelijk is. '
      }
    }
  }
}
</script>